/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

/**
 * Because we've been saving a lot of additional logger data in the localStorage for no particular reason
 * we need to, hopefully, unbrick user's devices by geting rid of unnecessary data.
 * */

if (window.localStorage) {
    Object.keys(window.localStorage).forEach((key) => {
        if (key.startsWith("loglevel:")) {
            window.localStorage.removeItem(key);
        }
    });
}
